import {
  Footer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
} from 'docx';

import { rodapeLogo } from './paragraph';

export function footerDoc(): Footer {
  return new Footer({
    children: [
      rodapeLogo(),
      new Table({
        rows: [
          new TableRow({
            children: [
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: 'SEDE ADMINISTRATIVA ',
                        bold: true,
                      }),
                      new TextRun({
                        text: 'Tv. João Francisco da Silveira (Barão de Maruim),44 Centro, CEP: 49.010-360 Tel.: (79) 3205-3800',
                      }),
                    ],
                  }),
                ],
                width: { size: 50, type: WidthType.PERCENTAGE }, // Ajusta a largura da célula
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: 'CENTRAL DE ATENDIMENTO ',
                        bold: true,
                      }),
                      new TextRun({
                        text: 'Avenida Ministro Geraldo Barreto Sobral, 1436 Jardins, CEP: 49.026-010, Aracaju/SE Tel: (79) 3205-3700',
                      }),
                    ],
                  }),
                ],
                width: { size: 50, type: WidthType.PERCENTAGE }, // Ajusta a largura da célula
              }),
            ],
          }),
        ],
      }),
    ],
  });
}
